import CategoryIcon from "@mui/icons-material/Category";
import MinimizeIcon from "@mui/icons-material/Minimize";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import React, { Component } from "react";
import { Col, Row, Card } from "reactstrap";
import FetchServerData from "../../provider/FetchServerData";
import store from "../../redux/store";
import { withRouter } from "../../withRouter";
import PtsButton from "../buttons/PtsButton";
import AddIcon from "@mui/icons-material/Add";

class MoveAsset extends Component {
  header = store.getState().header.header;
  constructor(props) {
    super(props);
    let assetIdList = [];
    let categoryId = "";
    if (props.state) {
      categoryId = props.state.categoryId;
      assetIdList = props.state.assetIdList;
    }
    this.getFullCatalogue(categoryId);
    this.state = {
      name: this.props.name,
      assetList: [],
      status: this.props.status,
      render: false,
      pageId: this.props.pageId,
      catalogueId: "",
      topCategories: [],
      categoryId: categoryId,
      categoryBreadCrumb: [],
      canAddAsset: false,
      childCategories: [],
      targetCategory: "",
      assetIdList: assetIdList,
      catalogueName: "",
      treeItemId: [],
      collapseTreeItem: [],
      checked: {},
    };
  }

  getFullCatalogue(categoryId) {
    const postObject = {
      header: this.header,
      category: {
        id: categoryId,
        sourceCategory: categoryId,
      },
    };
    FetchServerData.callPostService(
      "/categoryms/getFullHierarchy",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let assetMoveDetails = output.data.catalogue;
        for (let i = 0; i < assetMoveDetails.childCategories.length; i++) {
          assetMoveDetails.childCategories[i].id =
            assetMoveDetails.childCategories[i].id.toString();
        }
        this.setState({
          render: true,
          catalogueData: assetMoveDetails,
          assetList: assetMoveDetails.childCategories,
          catalogueId: assetMoveDetails.id,
          catalogueName: assetMoveDetails.name,
        });
      }
    });
  }

  moveAsset() {
    const postObject = {
      header: this.header,
      assetIds: this.state.assetIdList,
      // asset: {
      //   id: this.state.assetIdList,
      // },
      targetCategory: {
        id: this.state.targetCategory,
      },
    };
    FetchServerData.callPostService("/assetms/moveAssets", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          this.props.navigate("/category", {
            state: {
              view: "categoryView",
              categoryId: this.state.targetCategory,
              catalogueId: this.state.catalogueId,
            },
          });
        }
      }
    );
  }
  cancelMoveAsset() {
    this.props.navigate("/category", {
      state: {
        view: "categoryView",
        categoryId: this.state.categoryId,
        catalogueId: this.state.catalogueId,
      },
    });
  }
  handleSelectToggle = (event, nodeId) => {
    const index = this.state.treeItemId.indexOf(nodeId);
    const copyExpanded = [...this.state.treeItemId];
    if (index === -1) {
      copyExpanded.push(nodeId);
    } else {
      copyExpanded.splice(index, 1);
    }
    // setExpanded(copyExpanded);
    this.setState({
      treeItemId: copyExpanded,
    });
  };

  onSpanClick = (treeItemData) => {
    const id = String(treeItemData.id);
    const isChecked = this.state.checked[id] || false;

    this.setState((prevState) => ({
      checked: {
        ...prevState.checked,
        [id]: !isChecked, // toggle checkbox
      },
      targetCategory: treeItemData.id,
    }));
  };

  onSelectedChange = (event, selectedAsset) => {
    const { checked } = this.state;
    const checkedValues = { ...checked };
    checkedValues[event.target.name] = event.target.checked;
    this.setState((prevState, currState) => {
      return {
        ...prevState,
        checked: checkedValues,
        targetCategory: selectedAsset.id,
      };
    });
  };
  
  getTreeItemsFromData = (treeItems) => {
    return treeItems.map((treeItemData, index) => {
      let children = undefined;
      if (
        treeItemData.childCategories &&
        treeItemData.childCategories.length > 0
      ) {
        children = this.getTreeItemsFromData(treeItemData.childCategories);
      }
      if (treeItemData.selected === true) {
        this.state.treeItemId.push(treeItemData.id.toString());
      }

      const { checked } = this.state;
      const checkedValues = { ...checked };
      const checkedCount = Object.values(checkedValues).filter(
        (value) => value
      ).length;
      return (
        <TreeItem
          key={treeItemData.id}
          nodeId={treeItemData.id.toString()}
          // label={treeItemData.name}
          label={
            <ul style={{ listStyle: "none" }} key={index}>
              <li
                style={{
                  padding: "0.5em",
                }}
              >
                {treeItemData.canAddAsset &&
                treeItemData.canAddAsset === true ? (
                  <Row>
                    <Col>
                      <span
                        style={{
                          color: "black",
                          float: "left",
                          fontWeight:
                            treeItemData.selected === true ? "bold" : "none",
                        }}
                        onClick={() => this.onSpanClick(treeItemData)}
                      >
                        {treeItemData.name}
                      </span>
                      &nbsp;&nbsp;&nbsp;
                      {parseInt(treeItemData.id) !== this.state.categoryId ? (
                        <input
                          type="checkbox"
                          id="topping"
                          key={index}
                          style={{ float: "left", margin: " 0.35em 0.5em" }}
                          name={treeItemData.id}
                          onChange={(e) =>
                            this.onSelectedChange(e, treeItemData)
                          }
                          value={treeItemData.id}
                          checked={this.state.checked[treeItemData.id] || false}
                          disabled={
                            !checkedValues[treeItemData.id] && checkedCount > 0
                          }
                        />
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col>
                      <span
                        style={{
                          color: "black",
                          float: "left",
                          fontWeight:
                            treeItemData.selected === true ? "bold" : "none",
                        }}
                      >
                        {treeItemData.name}
                      </span>
                    </Col>
                  </Row>
                )}
              </li>
            </ul>
          }
          children={children}
        />
      );
    });
  };
  handleToggle = (event, nodeIds) => {
    this.setState({
      treeItemId: nodeIds,
    });
  };

  render() {
    if (!this.state.render || this.state.render === false) {
      return;
    }
    return (
      <>
        <Card
          style={{ overflowY: "auto", overflowX: "hidden", padding: " 1em" }}
        >
          <Row>
            <Col
              md={12}
              className="toolBarCol"
              style={{
                textTransform: "capitalize",
                margin: "0.5em auto auto auto",
              }}
            >
              <Row>
                <Col>
                  <CategoryIcon
                    style={{
                      color: "#DC7633",
                      fontSize: "18px",
                      marginBottom: "3px",
                      float: "left",
                    }}
                  />
                  &nbsp; &nbsp;
                  <span
                    style={{
                      color: " #DC7633",
                      fontWeight: "bold",
                      float: "left",
                    }}
                  >
                    &nbsp;{this.state.catalogueName}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TreeView
                    expanded={
                      this.state.treeItemId ? this.state.treeItemId : []
                    }
                    onNodeToggle={this.handleToggle}
                    onNodeSelect={this.handleSelectToggle}
                    collapsed={this.state.collapseTreeItem}
                    defaultCollapseIcon={
                      <MinimizeIcon
                        style={{
                          background: "gray",
                          color: "white",
                          paddingBottom: "0.4em",
                        }}
                      />
                    }
                    defaultExpandIcon={
                      <AddIcon style={{ background: "gray", color: "white" }} />
                    }
                  >
                    {this.getTreeItemsFromData(this.state.assetList)}
                  </TreeView>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <div
          className="modal-footer"
          style={{ padding: "1.2rem 1.5rem 1.5rem" }}
        >
          <PtsButton
            btnName="Move"
            type="submit"
            onClick={this.moveAsset.bind(this)}
          />

          <button
            type="button"
            className="btn btn-label-secondary fw-bold"
            data-bs-dismiss="modal"
            style={{ background: "#8592a3", color: "#fff" }}
            onClick={this.cancelMoveAsset.bind(this)}
          >
            Cancel
          </button>
        </div>
      </>
    );
  }
}

export default withRouter(MoveAsset);
